import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../app/store/utils/baseQueryWithReauth';

export const systemApi = createApi({
  reducerPath: 'systemApi',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    getEnv: build.query<string, void>({
      transformResponse: (response: { data: { node_env: string } }) =>
        response.data?.node_env ?? '',
      query: () => ({
        url: '/system-admin/env',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetEnvQuery } = systemApi;
